document.addEventListener('DOMContentLoaded', function() {
  const textWithIconsList = document.querySelector('.text-with-icons__list');

  if (textWithIconsList && window.innerWidth <= 768) { // Adjust the width as per your mobile breakpoint
    const elementPosition = textWithIconsList.getBoundingClientRect().top + window.scrollY;

    window.addEventListener('scroll', function() {
      const windowScrollTop = window.scrollY;
      if (windowScrollTop > elementPosition) {
        document.querySelector('.product-form').classList.add('cart-btn-sticky__onScroll');
        document.querySelector('body').classList.add('sticky-cart-btn__onScroll');
        document.querySelector('.product__info-wrapper').classList.remove('animate--slide-in');
      } else {
        document.querySelector('.product-form').classList.remove('cart-btn-sticky__onScroll');
        document.querySelector('body').classList.remove('sticky-cart-btn__onScroll');
        document.querySelector('.product__info-wrapper').classList.add('animate--slide-in');
      }
    });
  }
});
